import Service from "../../../Services/index";

const MaterialImport = {
    namespaced: true,
    state: {
        table: [],
        replace_data: [],
    },
    mutations: {
        REPLACE_MATERIAL: (state, res) => {
            state.replace_data = res;
        }
    },
    actions: {
        get({ commit },page=1) {
            return Service.importMaterial.getMaterialImport(page);
        },
        show({ commit }, id) {
            return Service.importMaterial
                .showMaterialImport(id)
                .then(response => {
                    commit("REPLACE_MATERIAL", response);
                });
        },
        create({ commit }, data) {
            return Service.importMaterial.createMaterialImport(data)
        },
        update({ commit }, { id, data }) {
            return Service.importMaterial.updateMaterialImport(id, data)
        },
        delete({ commit }, id) {
            return Service.importMaterial.deleteMaterialImport(id)
        },
        search({ commit }, {page="", code, date }) {
            return Service.importMaterial
                .searchMaterialImport(page,code, date);
        }
    }
};
export default MaterialImport;
